import { StaticBaseDao } from '@/dao';
import { RaceContestantPoints } from '@/objects/generated';

export class RaceContestantPointsDao extends StaticBaseDao {
    public static async GetRaceContestantPointsForContestant(EventID: number, contestantId: number): Promise<RaceContestantPoints[]> {
        return this.BaseFetchArray(
            RaceContestantPoints,
            `RaceContestantPoints/GetRaceContestantPointsForContestant` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (contestantId == undefined ? '' : `contestantId=${contestantId}`),
            'GET',
        );
    }
}
